/* eslint-disable react/prop-types */
import { palette, SolvTheme, Text } from '@solvhealth/jigsaw-v1';
import React, { FC } from 'react';
import styled from 'styled-components';
import { colors } from '../../../../../../../constants/colors';
import { biggerThanOrEqualTo, smallerThan } from '../../../../../../../core/util/styledComponents';

export const Details = styled.div.withConfig({ componentId: 'sc-17ylnu6-0' })`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  flex: 1;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 24px;

  ${biggerThanOrEqualTo.sm`
    padding-top: 12px;
  `}
`;

export const Root = styled.a.withConfig({ componentId: 'sc-17ylnu6-1' })`
  width: 100%;
  padding: 0 0 0 18px;
  cursor: pointer;
  box-sizing: border-box;
  background: url(/images/icons/arrow/Right_Carrot.svg) no-repeat 95% center white;
  transition: background-color 200ms ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 20px;

  &:hover {
    background-color: ${colors.whiteGrey};
  }

  &:not(:last-child) ${Details}, &:visited:not(:last-child) ${Details} {
    ${smallerThan.sm`
      border-bottom: 1px solid ${palette.gray[200]} !important;
    `}
  }

  ${smallerThan.sm`
    padding-top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  `};

  ${biggerThanOrEqualTo.sm`
    box-shadow: ${SolvTheme.shadows.sm};
    border-radius: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: unset;
  `}
`;

export const Icon = styled.img.withConfig({ componentId: 'sc-17ylnu6-2' })`
  ${smallerThan.sm`
    margin-right: ${SolvTheme.space[3]};
    height: 42px;
    width: 42px;
  `};
  width: 52px;
  height: 52px;
  flex-shrink: 0;
  object-fit: contain;
`;

export const Title: FC = ({ children }) => <Text variant="subtitle">{children}</Text>;

export const SubTitle: FC = ({ children }) => (
  <Text
    muted
    style={{ width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
    variant="body"
    width="100%"
  >
    {children}
  </Text>
);
